import React from 'react';
import { Typography } from 'antd';
import logo from '../img/supertcm_logo_with_name.png';
import overview from '../img/overview/supertcm-overview.svg';
import { size } from 'lodash';

const { Title } = Typography;
const PageHome: React.FC = () => (
    <div>
        <div style={{ backgroundColor: '#aaa', display: 'flex', justifyContent: 'center' }}>
            <img src={logo} alt="supertcm logo" style={{ height: '200px' }} />
        </div>
        <div style={{ padding: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <Title level={3} style={{ color: 'red' }}>
                    How to search the SuperTCM database
                </Title>
                <iframe
                    width="600"
                    height="400"
                    src="https://www.youtube.com/embed/i5_Z2OqRKnU"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                />
            </div>
        </div>
        <div style={{ padding: '8px' }}>
            <p>
                SuperTCM is a comprehensive database that covers the aspects of Traditional Chinese Medicine (TCM)
                derived from medicinal plants. It encompasses synergies in pharmaceutical recipes up to molecular
                ingredients. By tracing all Chinese plant-based drugs back to their source, i.e. their plant of origin,
                we mapped the drugs carefully, distinguishing common non-scientific plant names versus scientific names.
                Search for non-plant drugs, for common versus Chinese pharmaceutical names, as well as for disease names
                are additional features. We provide a compound similarity search through a connection to
                well-established compound database. Last but not least, we also projected the information on
                combinations of Chinese drugs in traditional recipes onto KEGG pathways.
            </p>
            <p>
                <strong>Please cite:</strong>
                <br />
                Chen Q, Springer L, Gohlke B, Goede A, Dunkel M, Abel R, Gallo K, Preissner S, Eckert A, Seshadri L and
                Preissner R
                <br />
                <a
                    href={'https://www.sciencedirect.com/science/article/pii/S0753332221010994'}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    SuperTCM: A biocultural database combining biological pathways and historical linguistic data of
                    Chinese Materia Medica for drug development{' '}
                </a>{' '}
                <br />
                Biomed Pharmacother 2021, PMID: 34656056, DOI: 10.1016/j.biopha.2021.112315
            </p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2% 5%' }}>
            <img src={overview} alt="supertcm overview" style={{ width: '100%' }} />
        </div>
    </div>
);

export default PageHome;
